import React from 'react';
import { Hero } from './components/Hero';
import { SystemSection } from './components/SystemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { InsideSection } from './components/InsideSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ivory font-sans text-navy" data-id="element-0" data-mp="31bibfrfi6shj">
      <Hero data-id="element-1" data-mp="2wka0us2ft12s" />
      <main data-id="element-2" data-mp="2wjgptewg3peu">
        <SystemSection data-id="element-3" data-mp="2wiyy8vkq9zd9" />
        <VolumesSection data-id="element-4" data-mp="2wifhhi6tdh0t" />
        <BonusSection data-id="element-5" data-mp="2wi5lndz38fn7" />
        <InsideSection data-id="element-6" data-mp="28u5vaf5our95" />
        <OfferSection data-id="element-7" data-mp="28te2fc3h77mk" />
        <FaqSection data-id="element-8" data-mp="28sl32w6ujkeg" />
      </main>
      <SiteFooter data-id="element-9" data-mp="23vchsmqej08z" />
      <PurchaseNotifications data-id="element-10" data-mp="23vuoyeelqyvo" />
    </div>;
}